import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { ResponsiveBar } from '@nivo/bar';
import Typography from '@material-ui/core/Typography';
import { prettyDate } from '../../lib/time';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    padding: '1.5rem',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignContent: 'flex-start',
    justifyContent: 'flex-start',
    cursor: 'pointer',
    border: `1px solid ${theme.palette.common.silver}`,
  },
  chart: {
    width: '100%',
    height: '16rem',
  },
}));

const BarChart = ({title, data}) => {
  const classes = useStyles();
  const formattedData = data.map(item => (
    {date: prettyDate(item.date, 'll'), value: item.value}
  ));
  return (
    <div className={classes.root}>
      <Typography variant="body2" align="left">{title}</Typography>
      <div className={classes.chart}>
        <ResponsiveBar
          data={formattedData}
          keys={[ 'value' ]}
          indexBy="date"
          margin={{ top: 20, right: 30, bottom: 80, left: 50 }}
          padding={0.2}
          colors={['#21bfaf']}
          borderColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
          minValue={0}
          axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 45,
          }}
          axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legendOffset: -50
          }}
          tooltip={({ value, data }) => (
            <span>
              {prettyDate(data.date, 'll')}: <strong>{value.toLocaleString()}</strong>
            </span>
          )}
          labelSkipWidth={12}
          labelSkipHeight={12}
          labelTextColor="#ffffff"
          animate={true}
          motionStiffness={90}
          motionDamping={15}
        />
      </div>
    </div>
  );
};

BarChart.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
};

export default BarChart;
